/* ============================================================
   STARFIT RACING — comportamiento global
   Countdown real · alternancia de videos hero · nav móvil
   Respeta prefers-reduced-motion.
   ============================================================ */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Countdown(s) de preventa ---------- */
  function initCountdowns() {
    var nodes = document.querySelectorAll("[data-countdown]");
    if (!nodes.length) return;
    nodes.forEach(function (el) {
      var target = new Date(el.getAttribute("data-countdown")).getTime();
      if (isNaN(target)) return;
      var out = {
        d: el.querySelector('[data-cd="days"]'),
        h: el.querySelector('[data-cd="hours"]'),
        m: el.querySelector('[data-cd="mins"]'),
        s: el.querySelector('[data-cd="secs"]')
      };
      function pad(n) { return (n < 10 ? "0" : "") + n; }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (out.d) out.d.textContent = "00";
          if (out.h) out.h.textContent = "00";
          if (out.m) out.m.textContent = "00";
          if (out.s) out.s.textContent = "00";
          el.setAttribute("data-done", "true");
          clearInterval(timer);
          return;
        }
        var days = Math.floor(diff / 86400000);
        var hrs = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
        if (out.d) out.d.textContent = pad(days);
        if (out.h) out.h.textContent = pad(hrs);
        if (out.m) out.m.textContent = pad(mins);
        if (out.s) out.s.textContent = pad(secs);
      }
      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  /* ---------- Hero: alterna 2 videos al terminar cada uno ---------- */
  function initHeroVideos() {
    var wraps = document.querySelectorAll("[data-hero-videos]");
    wraps.forEach(function (wrap) {
      var vids = wrap.querySelectorAll("video");
      if (vids.length < 2) {
        if (reduce && vids[0]) { try { vids[0].pause(); } catch (e) {} }
        return;
      }
      var i = 0;
      function show(n) {
        vids.forEach(function (v, k) {
          v.style.opacity = k === n ? "1" : "0";
          if (k === n) {
            v.currentTime = 0;
            if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          } else {
            v.pause();
          }
        });
      }
      vids.forEach(function (v, k) {
        v.removeAttribute("loop");
        v.addEventListener("ended", function () {
          i = (k + 1) % vids.length;
          show(i);
        });
      });
      if (reduce) { vids.forEach(function (v) { v.pause(); }); vids[0].style.opacity = "1"; }
      else { show(0); }
    });
  }

  /* ---------- Nav / filtros móviles: scroll horizontal (solo estado) ---------- */
  function initStickyHeader() {
    var h = document.querySelector("[data-sticky-header]");
    if (!h) return;
    var onScroll = function () {
      h.classList.toggle("is-scrolled", window.scrollY > 8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () {
    initCountdowns();
    initHeroVideos();
    initStickyHeader();
  });
})();
